import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AttendenceComponent } from 'src/app/features/auth/attendance/attendence.component';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { Requiredaction, UserRest } from 'src/app/models/auth/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SignalEventType } from 'src/app/services/signalR/SignalModel';
import { SignalRService } from 'src/app/services/signalR/SignalR.service';

@Component({
  selector: 'app-restaurants-dropdown',
  templateUrl: './restaurants-dropdown.component.html'
})
export class RestaurantsDropdownComponent implements OnInit {

  dataLoading = true;
  // Restaurant ID
  @Input() restaurantId?: any;
  @Input() hideLabel = false;
  allRestaurants: UserRest[] = [];

  @Output() all = new EventEmitter<Number>();
  @Output() isChanged = new EventEmitter<boolean>();

  currentRest!: UserRest | undefined;
  newRest!: UserRest | undefined;

  listSubscription!: Subscription;
  subscriptions: Subscription[] = [];

  actionsPermissions!: any;

  constructor(
    private restaurantService: RestaurantService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private signal: SignalRService,
  ) { }

  ngOnInit(): void {
    if (this.restaurantId) {
      localStorage.setItem('restaurantId', this.restaurantId)
    } else {
      this.restaurantId = localStorage.getItem('restaurantId');
    }
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.AttandanceFeature)
        .subscribe(message => { this.updateList(message.data); })
    )

    this.GetRestaurants();
    this.actionsPermissions = this.authenticationService.currentActionsPermissions;
    this.authenticationService.actionsPermissions.subscribe((data: any) => {
      this.actionsPermissions = data;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  updateList(data: any) {
    if (this.allRestaurants.some(r => r.id == data.RestaurantId)) {
      this.GetRestaurants(false);
    }
  }
  /** Get All Restaurants for Selection dropdown */
  GetRestaurants(sendOutput = true) {
    this.listSubscription?.unsubscribe();
    this.dataLoading = true;
    this.listSubscription = this.restaurantService.GetOwneRestaurant().subscribe((data: any) => {
      this.dataLoading = false;
      this.allRestaurants = data.pageData;
      let localStorageRestaurantValue = localStorage.getItem('restaurantId');
      if (localStorageRestaurantValue) {
        this.restaurantId = localStorageRestaurantValue
      } else {
        this.restaurantId = this.allRestaurants[0].id
        localStorage.setItem('restaurantId', this.restaurantId)
      }
      if (this.restaurantId && sendOutput) {
        this.all.emit(this.restaurantId)
      }
      this.currentRest = this.allRestaurants.find(r => r.id == this.restaurantId);
      let user = this.authenticationService.currentUserValue;
      if (user) {
        user.owneRestaurant = this.allRestaurants;
        this.authenticationService.currentUserSubject.next(user);
      }
    })
  }


  getSelectedRestaurant(restaurantId: any) {
    this.newRest = this.allRestaurants.find(r => r.id == restaurantId);

    // CurrentRest
    if (
      this.currentRest?.attendancefeature
      && this.currentRest?.requiredaction != Requiredaction.NoAction
    ) {
      if (this.currentRest?.requiredaction == Requiredaction.ClockOut) {
        this.openAttendenceDialog(this.currentRest.id, Requiredaction.ClockOut);
      }
      if (this.currentRest?.requiredaction == Requiredaction.ClockIn) {
        this.openAttendenceDialog(this.currentRest.id, Requiredaction.ClockIn);
      }
    }

    // NewRest
    if (
      this.newRest?.attendancefeature
      && this.newRest?.requiredaction != Requiredaction.NoAction
    ) {
      if (this.newRest?.requiredaction == Requiredaction.ClockOut) {
        this.openAttendenceDialog(this.newRest.id, Requiredaction.ClockOut);
      }
      if (this.newRest?.requiredaction == Requiredaction.ClockIn) {
        this.openAttendenceDialog(this.newRest.id, Requiredaction.ClockIn);
      }
    }


    if (
      !(
        this.currentRest?.attendancefeature
        && this.currentRest?.requiredaction != Requiredaction.NoAction
      )
      &&
      !(
        this.newRest?.attendancefeature
        && this.newRest?.requiredaction != Requiredaction.NoAction
      )
    ) {
      this.setCurrentRest();
    }

    this.authenticationService.updateActionsPermissions.next(true);
  }

  openAttendenceDialog(restaurantId: number, action: Requiredaction) {
    const dialogRef = this.dialog.open(AttendenceComponent, {
      width: '400px',
      data: { action, restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (action == Requiredaction.ClockOut) {
          // After ClockOut Need to ClockIn
          // if (this.newRest) {
          //   this.openAttendenceDialog(this.newRest?.id, Requiredaction.ClockIn);
          // }
        } else {
          this.GetRestaurants(false);
          this.setCurrentRest();
        }
      } else {
        this.restaurantId = this.currentRest?.id;
      }
    });
  }

  setCurrentRest() {
    this.currentRest = this.allRestaurants.find(r => r.id == this.newRest?.id);
    localStorage.setItem('restaurantId', String(this.newRest?.id))
    this.isChanged.emit(true);
    this.all.emit(this.newRest?.id);
  }
}
